import React, { useEffect } from "react"
import { useNavigate, useSearchParams, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"

import LoadingOverlay from "../../components/LoadingOverlay"
import { useIdentification } from "../../api/hooks/useIdentification"
import { ROUTES_PATHS } from "../../utils/constants"
import { setPaymentToken, setPaymentId } from "../../store/slices/payment"

const Identification = () => {
  const { id } = useParams()
  const { data } = useIdentification()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    // Сохраняем token из searchParams
    const token = searchParams.get("token")
    if (token) {
      dispatch(setPaymentToken(token))
    }

    // Сохраняем id из params
    if (id) {
      dispatch(setPaymentId(id))
    }
  }, [searchParams, id, dispatch])

  useEffect(() => {
    if (data?.status === "Accepted" || data?.status === "Rejected") {
      navigate({
        pathname: `/${ROUTES_PATHS.topUpMbankAccount}/${
          // data?.status === "Accepted" ? "identification/success" : "absent-data"
          data?.status === "Accepted" ? "identification/success" : "identification/failed"
        }`,
        search: searchParams.toString(),
      })
    }
  }, [data?.status])

  return (
    <LoadingOverlay
      disableOpacity
      title="Идет проверка данных"
      text={
        <>
          Она может занять некоторое время. <br /> Дождитесь окончания процесса
        </>
      }
    />
  )
}

export default Identification
